import cloudIcon from 'img/cloud_blue.svg?url';
import cloudIconNew from 'img/cloud_blue_new.svg?url';
import { QRCodeCanvas } from 'qrcode.react';
import React, { type ReactElement, memo } from 'react';
import { isRebranding } from 'reactApp/appHelpers/featuresHelpers';

interface Props {
    url: string;
    size?: number;
    isDark?: boolean;
}

const imageSettings = {
    src: isRebranding ? cloudIconNew : cloudIcon,
    height: 28,
    width: 28,
    excavate: true,
};

export const QRCloud = memo(({ url, size = 156, isDark = false }: Props): ReactElement | null => {
    return (
        <QRCodeCanvas
            value={url}
            size={size}
            imageSettings={imageSettings}
            bgColor={'transparent'}
            fgColor={isDark ? '#ffffff' : '#2c2d2e'}
        />
    );
});

QRCloud.displayName = 'QRCloud';
